import React from "react";
import { Spin, Row, Col, Radio } from "antd";
import global from "../../../common/utility/global";
import Header from "../../../components/Header";
import Filters from "./Filters";
import anioMock from '../../../common/mock/anioMock';
import mesMock from '../../../common/mock/mesMock';
import compraService from "../../../service/logistica/compraService";
import KpiCard from "./KpiCard";
import ChartPanel from "./ChartPanel";
import GraficoTopCompra from "./GraficoTopCompra";
import GraficoEvolucionCompra from "./GraficoEvolucionCompra";
import GraficoCategoriaCompra from "./GraficoCategoriaCompra";
import { buildDashboardData, formatCurrency, formatNumber, formatTendencia } from "./utils";
import "./styles.css";

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        // Por defecto el periodo es el mes actual (inicio = fin); con eso,
        // el grafico de Evolucion arranca mostrando dias. Si el usuario
        // amplia el rango a mas de un mes, ese mismo grafico pasa a mostrar
        // un punto por mes.
        const filter = {
            anioInicio: global.fetchCurrentYear(),
            mesInicio: global.fetchCurrentMonth(),
            anioFin: global.fetchCurrentYear(),
            mesFin: global.fetchCurrentMonth(),
            flagNotaVenta: false,
        };
        this.state = {
            loading: true,
            moneda: "PEN",
            anios: anioMock.values,
            meses: mesMock.values,
            filter,
            dashboard: buildDashboardData(null, filter),
        };
    }

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleChangeMoneda = (e) => {
        this.setState({ moneda: e.target.value });
    };

    handleClearFilters = () => {
        const filter = {
            anioInicio: global.fetchCurrentYear(),
            mesInicio: global.fetchCurrentMonth(),
            anioFin: global.fetchCurrentYear(),
            mesFin: global.fetchCurrentMonth(),
            flagNotaVenta: false,
        };
        this.setState({ filter, moneda: "PEN" });
        this.handleGenerateReport(filter);
    };

    handleGenerateReport = async (filter) => {
        this.setState({
            loading: true,
        });
        const response = await compraService.dashboardCompra(filter);
        this.setState({
            dashboard: buildDashboardData(response, filter),
            loading: false,
        });
    };

    async componentDidMount() {
        await this.handleGenerateReport(this.state.filter);
    }

    render() {
        const { moneda, filter } = this.state;
        const { kpis, topProveedores, categorias, evolucion } = this.state.dashboard;
        const clave = moneda === "USD" ? "usd" : "pen";
        const esMismoMes = filter.anioInicio === filter.anioFin && filter.mesInicio === filter.mesFin;
        const tituloEvolucion = `Evolución de Compras (${esMismoMes ? "diaria" : "mensual"}) vs periodo anterior`;
        const textoComparacion = esMismoMes ? "vs mes anterior" : "vs periodo anterior";

        return (
            <div>
                <Header
                    title="Dashboard Resumen Compras"
                    onClearFilters={this.handleClearFilters}
                    onSearch={() => this.handleGenerateReport(this.state.filter)}
                />
                <Filters filter={this.state.filter} anios={this.state.anios} meses={this.state.meses} onChange={this.handleChange} />
                <div className="moneda-toggle">
                    <Radio.Group value={moneda} onChange={this.handleChangeMoneda} buttonStyle="solid">
                        <Radio.Button value="PEN">S/ Soles</Radio.Button>
                        <Radio.Button value="USD">US$ Dólares</Radio.Button>
                    </Radio.Group>
                </div>
                <Spin tip="Cargando..." size="large" spinning={this.state.loading}>
                    <div className="kpi-tile-row">
                        <KpiCard
                            icon="shopping"
                            iconColor="#2563eb"
                            iconBackground="#eff6ff"
                            label={esMismoMes ? "Compras del Mes" : "Compras del Periodo"}
                            value={formatCurrency(kpis.totalCompras[clave].valor, moneda)}
                            tendenciaDireccion={kpis.totalCompras[clave].tendenciaDireccion}
                            tendenciaValor={formatTendencia(kpis.totalCompras[clave].tendenciaPct)}
                            tendenciaTexto={textoComparacion}
                        />
                        <KpiCard
                            icon="file-text"
                            iconColor="#16a34a"
                            iconBackground="#ecfdf5"
                            label="Órdenes de Compra"
                            value={formatNumber(kpis.comprobantes.valor, 0)}
                            tendenciaDireccion={kpis.comprobantes.tendenciaDireccion}
                            tendenciaValor={formatTendencia(kpis.comprobantes.tendenciaPct)}
                            tendenciaTexto={textoComparacion}
                        />
                        <KpiCard
                            icon="team"
                            iconColor="#7c3aed"
                            iconBackground="#f3e8ff"
                            label="Proveedores Nuevos"
                            value={formatNumber(kpis.proveedoresNuevos.valor, 0)}
                            tendenciaDireccion={kpis.proveedoresNuevos.tendenciaDireccion}
                            tendenciaValor={formatTendencia(kpis.proveedoresNuevos.tendenciaPct)}
                            tendenciaTexto={textoComparacion}
                        />
                        <KpiCard
                            icon="dollar"
                            iconColor="#d97706"
                            iconBackground="#fff7ed"
                            label="Cpe Promedio"
                            value={formatCurrency(kpis.compraPromedio[clave].valor, moneda)}
                            tendenciaDireccion={kpis.compraPromedio[clave].tendenciaDireccion}
                            tendenciaValor={formatTendencia(kpis.compraPromedio[clave].tendenciaPct)}
                            tendenciaTexto={textoComparacion}
                        />
                    </div>

                    <Row gutter={16}>
                        <Col className="gutter-row" xs={24} lg={12}>
                            <ChartPanel title="Top 10 Proveedores por Compras">
                                <GraficoTopCompra datos={topProveedores[clave]} moneda={moneda} />
                            </ChartPanel>
                        </Col>

                        <Col className="gutter-row" xs={24} lg={12}>
                            <ChartPanel title="Compras por Categoría">
                                <GraficoCategoriaCompra datos={categorias[clave]} moneda={moneda} />
                            </ChartPanel>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <ChartPanel title={tituloEvolucion}>
                                <GraficoEvolucionCompra
                                    timeLine={evolucion.timeLine}
                                    series={evolucion[clave]}
                                    moneda={moneda}
                                />
                            </ChartPanel>
                        </Col>
                    </Row>
                </Spin>
            </div>
        );
    }
}
